//client/src/components/ArticleDetail.js
import React from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { getArticleBySlug } from '../utils/articlesData';

const ArticleDetail = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const article = getArticleBySlug(slug);

  // Handle case where article is not found
  if (!article) {
    return (
      <div className="max-w-3xl mx-auto px-4 py-16 text-center">
        <h2 className="text-2xl font-bold text-gray-800 mb-4">Article not found</h2>
        <p className="text-gray-600 mb-6">The article you're looking for doesn't exist.</p>
        <button 
          onClick={() => navigate('/articles')}
          className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors"
        >
          Back to Articles
        </button>
      </div>
    );
  }

  return (
    <div className="max-w-3xl mx-auto px-4 py-8">
      <Link 
        to="/articles" 
        className="inline-block mb-8 text-gray-600 hover:text-gray-800"
      >
        ← Back to Articles
      </Link>
      
      <article>
        <h1 className="text-4xl font-bold text-gray-800 mb-4">{article.title}</h1>
        <div className="text-sm text-gray-500 mb-8">
          <span>{article.date}</span>
          <span className="mx-1">•</span>
          <span>{article.author}</span>
        </div>
        <div 
          className="prose prose-lg max-w-none"
          dangerouslySetInnerHTML={{ __html: article.content }}
        />
      </article>
            <section className="bg-gradient-to-r mt-12 from-blue-600 to-indigo-700 text-white py-16 w-screen right-[50%] relative left-[50%] right-[50%] mx-[-50vw]">
              <div className="container max-w-4xl mx-auto px-6 text-center">
                <h2 className="text-4xl font-bold mb-4">Next, Make your own custom QR code</h2>
                <p className="text-xl mb-8 max-w-2xl mx-auto">It's easy and fun! Join other data-driven businesses using BoxyQR to customize and track QR codes and links.</p>
      <Link to="/sign-up" className="bg-white text-blue-700 border-2 border-white hover:bg-blue-200 hover:text-blue-800 px-10 py-5 rounded-lg font-semibold transition duration-200">
      Create Three Free QR Codes
                </Link>
                <p className="mt-8 text-sm opacity-80">QR codes & link tracking • Real-time analytics</p>
              </div>
            </section>
    </div>
  );
};

export default ArticleDetail;